import type { ReactNode } from "react";
import { FiInfo } from "react-icons/fi";

export interface InfoNoteProps {
  /** Título en negrita (color de aviso). */
  title: string;
  /** Mensaje. */
  children: ReactNode;
}

/** Nota informativa dentro de una vista: contorno de aviso, icono y texto (el color no es el único indicio). */
export function InfoNote({ title, children }: InfoNoteProps) {
  return (
    <div role="note" className="flex items-start gap-3 rounded-[var(--ds-radius-md)] border-[1.5px] border-[var(--ds-warning)] px-4 py-3 text-sm leading-5 text-[var(--ds-ink)]">
      <FiInfo aria-hidden="true" className="mt-0.5 size-[22px] flex-none text-[var(--ds-warning)]" />
      <div className="min-w-0">
        <strong className="font-medium text-[var(--ds-warning)]">{title}</strong>
        <br />
        {children}
      </div>
    </div>
  );
}
